import Backbone from "backbone";
import { View } from "../database-reader/base-database-reader";
import { DB_PROVIDERS } from "../database-reader/configs/db-providers";
const module = {};
class SalesforceCDCView extends View {
    setup() {
        this.label = "Salesforce CDC";
        this.model.get("connectionParams").set("type", DB_PROVIDERS.SALESFORCE.id);
        this.model.set("isCDC", true);
    }
}

module.View = SalesforceCDCView;
module.vent = new Backbone.Model();
export default module;
